<template>
  <div
    v-if="modalTrigger"
    class="column-property-modal"
    :style="modalStyle"
  >
    <div class="header">
      <!-- <div class="reset-btn" @click="resetColumnPropertySetting">回到預設</div> -->
      <div class="save-btn" @click="saveColumnPropertySetting">儲存</div>
    </div>
    <div class="columns-content">
      <div class="title-show">顯示</div>
      <div ref="selectedColumns" class="show-columns">
        <div
          v-for="(selected, index) in selecteds"
          :key="selected.ColumnName"
          class="column"
          :class="{
            dragging: draggingIndex === index,
            pushed: pushedIndexes.includes(index),
          }"
          :style="[
            index == selecteds.length - 1
              ? 'border-bottom:1px solid #F2F2F2'
              : 'border-bottom:1px solid rgba(255, 255, 255,0)',
            getItemStyle(index),
          ]"
          @click.prevent="handleCheckboxClick(selected, index, $event)"
        >
          <label :for="selected.ColumnName"
            ><input
              :id="selected.ColumnName"
              class="custom-control-input"
              type="checkbox"
              checked="checked"
            />
            <span class="custom-checkbox"
              ><img :src="$img.get('Icon/Checked.svg')" alt="Checked" /></span
            ><span class="checkbox-name">{{ selected.text }}</span></label
          >
          <div
            class="dragger"
            @mousedown="handleDraggerMouseDown(index, $event)"
          >
            <img :src="$img.get('Tools/Arrange.svg')" alt="Arrange" />
          </div>
        </div>
      </div>
      <div class="title-hide">不顯示</div>
      <div class="hide-columns">
        <div
          v-for="(notSelected, index) in notSelecteds"
          :key="notSelected.ColumnName"
          class="column"
          :style="
            index == notSelecteds.length - 1
              ? 'border-bottom:1px solid #F2F2F2'
              : ''
          "
          @click="isVisibleChange(notSelected, index)"
        >
          <label :for="notSelected.ColumnName"
            ><input
              :id="notSelected.ColumnName"
              class="custom-control-input"
              type="checkbox"
              v-model="notSelected.IsVisible"
              checked="checked"
            />
            <span class="custom-checkbox"
              ><img :src="$img.get('Icon/Checked.svg')" alt="Checked" /></span
            ><span class="checkbox-name">{{ notSelected.text }}</span></label
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      selecteds: [],
      notSelecteds: [],
      modalTrigger: false,
      originalBodyOverflow: "",
      // 抓取調整排序
      draggingIndex: null,
      targetIndex: null,
      isDragging: false,
      initialMouseY: null,
      currentOffsetY: 0,
      pushedIndexes: [],
      cancelClick: false,
    };
  },
  props: ["trigger", "columns", "position", "isSelector", "highestZIndex"],
  emits: ["onSaved"],
  computed: {
    modalStyle() {
      const padding = 8;
      const viewportTop = window.scrollY + padding;
      const viewportBottom = window.scrollY + window.innerHeight - 100;
      const safeTop = Math.max(
        viewportTop,
        Math.min(this.position.top, viewportBottom)
      );
      let safeRight = this.position.right;
      if (this.isSelector) {
        safeRight += 10;
      }
      return {
        position: "absolute",
        top: `${safeTop}px`,
        right: `${safeRight}px`,
        maxHeight: "90vh",
        zIndex: this.highestZIndex || 100,
      };
    },
  },
  watch: {
    // columns: {
    //   handler: function () {
    //     this.updateSelect();
    //   },
    //   deep: true,
    //   immediate: true,
    // },
    trigger(value) {
      this.updateSelect();
      this.modalTrigger = value;
      if (value) {
        this.originalBodyOverflow = document.body.style.overflow;
        document.body.style.overflow = "hidden";
      } else {
        document.body.style.overflow = this.originalBodyOverflow;
      }
    },
  },
  methods: {
    updateSelect() {
      let copy = this.$func.copy(this.columns);
      this.selecteds = [];
      this.notSelecteds = [];
      copy.forEach((column) => {
        if (column.IsVisible) {
          this.selecteds.push(column);
        } else {
          this.notSelecteds.push(column);
        }
      });
    },
    isVisibleChange(notSelected, index) {
      notSelected.IsVisible = true;
      this.notSelecteds.splice(index, 1);
      this.selecteds.push(notSelected);
    },
    handleCheckboxClick(selected, index, e) {
      if (this.cancelClick) {
        e.preventDefault();
        e.stopPropagation();
        return;
      }
      selected.IsVisible = false;
      this.selecteds.splice(index, 1);
      this.notSelecteds.push(selected);
    },
    saveColumnPropertySetting() {
      if (this.selecteds.length == 0) {
        this.$func.message({
          type: "alert",
          mainMessage: "最少需設定一個欄位 !",
        });
        return;
      }
      let position = 1;
      this.selecteds.forEach((det) => {
        det.Position = position;
        position = position + 1;
      });
      this.$emit("onSaved", this.selecteds.concat(this.notSelecteds));
    },
    handleDraggerMouseDown(index, e) {
      e.preventDefault();
      this.draggingIndex = index;
      this.targetIndex = index;
      this.isDragging = true;
      this.initialMouseY = e.clientY;
      document.addEventListener("mousemove", this.onDrag);
      document.addEventListener("mouseup", this.stopDrag);
      document.body.style.cursor = "grabbing";
    },
    onDrag(e) {
      if (!this.isDragging) return;
      this.cancelClick = true;
      const deltaY = e.clientY - this.initialMouseY;
      this.currentOffsetY = deltaY;

      const items = this.$refs.selectedColumns.querySelectorAll(".column");
      const itemHeight = items[0].offsetHeight;
      const estimatedIndex =
        this.draggingIndex + Math.round(deltaY / itemHeight);
      const clampedIndex = Math.max(
        0,
        Math.min(estimatedIndex, this.selecteds.length - 1)
      );

      this.targetIndex = clampedIndex;

      this.pushedIndexes = [];
      for (let i = 0; i < this.selecteds.length; i++) {
        if (i === this.draggingIndex) continue;
        if (
          this.draggingIndex < this.targetIndex &&
          i > this.draggingIndex &&
          i <= this.targetIndex
        ) {
          this.pushedIndexes.push(i);
        } else if (
          this.draggingIndex > this.targetIndex &&
          i >= this.targetIndex &&
          i < this.draggingIndex
        ) {
          this.pushedIndexes.push(i);
        }
      }
    },
    stopDrag() {
      if (
        this.draggingIndex !== null &&
        this.targetIndex !== null &&
        this.draggingIndex !== this.targetIndex
      ) {
        const item = this.selecteds.splice(this.draggingIndex, 1)[0];
        this.selecteds.splice(this.targetIndex, 0, item);
      }

      setTimeout(() => {
        this.cancelClick = false;
      }, 100);
      this.isDragging = false;
      this.draggingIndex = null;
      this.targetIndex = null;
      this.currentOffsetY = 0;
      this.pushedIndexes = [];
      document.removeEventListener("mousemove", this.onDrag);
      document.removeEventListener("mouseup", this.stopDrag);
      document.body.style.cursor = "";
    },
    getItemStyle(index) {
      if (index === this.draggingIndex && this.isDragging) {
        return `transform: translateY(${this.currentOffsetY}px); z-index: 10;`;
      } else if (this.pushedIndexes.includes(index)) {
        const items = this.$refs.selectedColumns.querySelectorAll(".column");
        const offset = items[0]?.offsetHeight || 0;
        return `transform: translateY(${
          this.draggingIndex < this.targetIndex ? -offset : offset
        }px);`;
      }
      return "";
    },
  },
  mounted() {
    this.$nextTick(() => {
      // 確保組件已經渲染
      if (!this.$refs.sequenceList) return;

      // 使用容器 ref 來查找元素
      const items = this.$refs.selectedColumns.querySelectorAll(".column");
      items.forEach((item) => {
        const dragger = item.querySelector(".dragger");
        const index = parseInt(item.getAttribute("data-index"));

        if (dragger) {
          dragger.addEventListener("touchstart", (e) => {
            e.preventDefault();
            // 創建一個模擬的事件對象，包含clientY
            const touchEvent = {
              clientY: e.touches[0].clientY,
            };
            this.startActualDrag(index, touchEvent);
            document.addEventListener("touchmove", this.onTouchDrag);
            document.addEventListener("touchend", this.stopTouchDrag);
          });
        }
      });
    });
  },
  beforeUnmount() {
    document.body.style.overflow = this.originalBodyOverflow;
  },
};
</script>

<style lang="scss" scoped>
.dragger {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 5px;
  &:hover {
    cursor: grab;
  }
}
.dragging {
  background-color: rgba(255, 255, 255, 0.8);
  border-bottom: 1px solid #f2f2f2 !important;
}
.column-property-modal {
  position: absolute;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 16px;
  padding: 10px;
  min-width: 250px;
  max-height: 90vh;
  background-color: white;
  border-radius: 12px;
  box-shadow: 0px 1px 5px rgba(0, 0, 0, 0.16);
  z-index: 92;
  .title-show,
  .title-hide {
    width: 100%;
    margin-bottom: 10px;
    color: #8d8d8d;
    font-size: 14px;
  }
  .show-columns,
  .hide-columns {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    margin-bottom: 16px;
  }
  .column {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    padding: 10px 0;
    border-top: 1px solid #f2f2f2;
    .arrow-btns {
      display: flex;
      justify-content: center;
      align-items: center;
      .arrow-btn {
        cursor: pointer;
        width: 24px;
        height: 24px;
      }
      &:hover {
        filter: brightness(1.1);
      }
    }
  }
}
.header {
  cursor: pointer;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 100%;
  .reset-btn,
  .save-btn {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: 10px;
    padding: 5px;
    color: #4695c9;
    font-weight: 500;
  }
}
.columns-content {
  width: 100%;
  padding: 0 10px;
  overflow: auto;
}
</style>
